/**
 * Efectos de browser (descargas, abrir pestañas). Vive fuera de `src/lib/`
 * a propósito: `lib` es puro y testeable sin DOM, esto es lo contrario.
 *
 * Por qué no un `<a href>` directo al API: cuando `SCOUT_API_TOKEN` está
 * seteado, el `.dvw` y la planilla imprimible también exigen el header
 * `Authorization`, y un link del browser no lo manda. Así que se baja el
 * contenido con `fetch` (que sí lleva el header) y se abre como Blob local.
 */

/** Dispara la descarga de un texto como archivo. */
export function saveTextAs(filename: string, body: string, contentType: string): void {
  const blob = new Blob([body], { type: contentType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Se libera con un respiro: Safari necesita que el click ya haya ocurrido.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Abre HTML en una pestaña nueva (la planilla imprimible). */
export function openHtmlInTab(html: string): void {
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank', 'noopener');
  if (!win) {
    // Popup bloqueado: al menos que quede el archivo.
    saveTextAs('reporte.html', html, 'text/html;charset=utf-8');
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
